import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Popover from '../../components/uielements/popover';
import IntlMessages from '../../components/utility/intlMessages';
import TopbarDropdownWrapper from './TopbarDropdown.styles';
import { handleLogout } from '../../redux-new/auth/auth.slice';
import { getAuthenticateData } from '../../library/helpers/utility';
import { PRIVATE_ROUTE } from '../../route.constants';

export default function TopbarUser() {
  const [visible, setVisibility] = React.useState(false);
  const dispatch = useDispatch();
  function handleVisibleChange() {
    setVisibility((visible) => !visible);
  }

  const content = (
    <TopbarDropdownWrapper className="isoUserDropdown">
      <Link className="isoDropdownLink" to={PRIVATE_ROUTE.MY_PROFILE}>
        <IntlMessages id="topbar.myprofile" />
      </Link>
      <div className="isoDropdownLink" onClick={() => dispatch(handleLogout())}>
        <IntlMessages id="topbar.logout" />
      </div>
    </TopbarDropdownWrapper>
  );

  const getUserInitialLetters = () => {
    const data = getAuthenticateData();
    const name = data ? data.authenticate.scaAccount.name : null;
    const surname = data ? data.authenticate.scaAccount.surname : null;

    if (name != null && surname != null) {
      return `${name.charAt(0).toUpperCase()}${surname
        .charAt(0)
        .toUpperCase()}`;
    }
    return 'U';
  };

  return (
    <Popover
      content={content}
      trigger="click"
      visible={visible}
      onVisibleChange={handleVisibleChange}
      arrowPointAtCenter={true}
      placement="bottomLeft"
    >
      <div className="isoImgWrapper">
        <div>
          <p>{getUserInitialLetters()}</p>
        </div>
      </div>
    </Popover>
  );
}
